<mng-fill-form (formSave)="onFormSave($event)" (formSubmit)="onFormSubmit($event)" *ngIf="formOptions['urlBackend'] && formOptions['urlBackendAccessControl'] && !errorMessage" [inputProperties]="formOptions"></mng-fill-form>

<div *ngIf="errorMessage" class="message-container container-fluid full-width">
  <div  class="alert alert-danger" role="alert">
      {{errorMessage}}
  </div>
</div>